/* eslint-disable @next/next/no-img-element */
import * as Scroll from 'react-scroll';
import {useEffect, useState} from 'react';
import HeadingServices from '../HeadingServices';
import {useWindowSize} from '../../../hooks/useWindowSize';
import Paragraf from '../Paragraf';
import HeadingTitle from '../HeadingTitle';
import CyberModal from '../consultancy/CyberModal';
import { useSelector, useDispatch } from 'react-redux';
import { set_modal } from '../../../redux/actions/appActions'
import PlayIcon from '../../ui/svgs/PlayIcon';
import CaretRight from '../../ui/svgs/CaretRight';
import { useRouter } from 'next/router';

export default function PenetrationTest({datasPentest, locale}) {

    let Link = Scroll.Link;
    const router = useRouter()
    const [height, setHeight] = useState(0);
    let size= useWindowSize();
    const isModal = useSelector(state => state.app.isModalPos)
    const dispatch = useDispatch();

    let arrayPen = [
        {id:"pentest1", name:datasPentest.pTitleOne, active:true},
        {id:"pentest2", name:datasPentest.pNineTitle, active: false},
        {id:"pentest3", name:datasPentest.pTenTitle, active: false},
        {id:"pentest4", name:datasPentest.pElevenTitle, active: false},
        {id:"pentest5", name:datasPentest.pTwelveTitle, active: false},
        {id:"pentest6", name:datasPentest.pThirteenTitle, active: false},
        {id:"pentest7", name:datasPentest.pFourteenTitle, active: false},
        {id:"pentest8", name:datasPentest.pFifteenTitle, active: false},
        {id:"pentest9", name:datasPentest.pSixteenTitle, active: false}
    ]

    const [activeStatus, setActiveStatus] = useState(arrayPen)

    const setActiveStatusHandler = (name) => {
        const newActiveStatus = activeStatus.map(item => {
            if(item.id === name){
                item.active = true;
                return item;
            }
            item.active =false;
            return item;
        })
        setActiveStatus(newActiveStatus);
    }
    
    useEffect(() => {
        const eventEl = () => {
            if (window.scrollY !== 0) {
                setHeight(window.scrollY);  
            } else {
                setHeight(0);
            }
        }
        window.addEventListener('scroll', eventEl);
        return (() =>
            window.removeEventListener('scroll', eventEl))
    }, []);

    const toggleModal = (pos) => {
        dispatch(set_modal(pos))
    }

    useEffect(() => {
        setActiveStatus(arrayPen)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.locale])

    return (
        <div onClick={() => {if(isModal)toggleModal(false)}}>
            {locale==="tr" && 
            <CyberModal 
                shown={isModal} 
                close={toggleModal} 
                src='https://www.youtube.com/embed/CHtQ_6rEYMA'/>
            }
            
            <HeadingServices title={datasPentest.upperTitle} lowerTitle={datasPentest.pTitleOne}/>
            <div className="container my-3 my-lg-5">
                <div className="row">
                    <div className="col-lg-3">
                        <aside className="sidebar" 
                            id="sidebarPentest"
                            style={height > 150 && size.width  > 991 ? 
                            {position:"sticky", top:"10em", bottom:"1em"}: {}}>
                            { height > 150 &&
                            <h2 className="font-weight-semi-bold line-height-3 text-primary text-6 mb-0"> {datasPentest.upperTitle} </h2>}
                            <h5 className="font-weight-semi-bold line-height-3 text-color-secondary text-5" style={{textTransform:"capitalize"}}> {datasPentest.documentTitle} </h5>
                            <ul className="nav nav-list flex-column mb-lg-5 mb-2">
                                {activeStatus.map((item,i) =>{
                                     return (
                                    <li className="nav-item line-height-2" key={item.id}>
                                        <Link className="nav-link text-4"
                                            activeClass="active"
                                            onClick= {() => setActiveStatusHandler(item.id)}
                                            spy={true}
                                            
                                            style={{cursor:"pointer"}} 
                                            offset={i=== 0 ? -250: -120}
                                            to={item.id}
                                            smooth >
                                            <CaretRight className="mb-1"/> {item.name}
                                                 
                                            </Link>
                                     </li> )
                                })}
                            </ul>
                        </aside>
                    </div>
                    <div className="col-lg-9">
                        <div id="pentest1">
                        <div className="position-relative float-right img-fluid img-small-width pl-md-3 pb-2" >
                                <img
                                    width="100%"
                                    height="100%"
                                    src="/images/pentest/pentest_two.png"
                                    alt="pentest video" 
                                /> 
                                {locale ==="tr" && <button type="button" 
                                onClick={() => toggleModal(true)}
                                className="position-absolute top-50pct left-50pct transform3dxy-n50  
                                rounded-circle d-flex align-items-center justify-content-center  
                                play-button-lg pulseAnim pulseAnimAnimated"  >
                                        <PlayIcon />
                                </button>}
                            
                        </div>
                        
                        <Paragraf parag={datasPentest.pOne} />
                        <Paragraf parag={datasPentest.pTwo} />
                        <Paragraf parag={datasPentest.pTwoA} />
                        <Paragraf parag={datasPentest.pTwoB} />
                        <Paragraf parag={datasPentest.pTwoC} />
                        <p className="text-5 line-height-2 text-dark" > 
                            <strong className="font-weight-extra-bold">{datasPentest.pThreeTitle} 
                            </strong>{datasPentest.pThree} 
                        </p>
                        <p className="text-5 line-height-2 text-dark"> 
                            <strong className="font-weight-extra-bold">{datasPentest.pFourTitle} </strong>
                            {datasPentest.pFour} 
                        </p>
                        

                        <p className="text-5 line-height-2 text-dark">
                            <strong className="font-weight-extra-bold">{datasPentest.pFiveTitle} </strong> 
                            {datasPentest.pFive} </p>
                            <Paragraf parag={datasPentest.pSix} />
                            
                        <p className="text-5 line-height-2 text-dark">
                            <strong className="font-weight-extra-bold">{datasPentest.pSevenTitle} </strong> 
                            {datasPentest.pSeven} 
                        </p>
                        <p className="text-5 line-height-2 text-dark" >
                            <strong className="font-weight-extra-bold">{datasPentest.pEightTitle} </strong> 
                            {datasPentest.pEight} 
                        </p>
                        </div>
                        <HeadingTitle title={datasPentest.titleMet}/>
                        <div id="pentest2"> 
                        <HeadingTitle title={datasPentest.pNineTitle} />
                        <Paragraf parag={datasPentest.pNine} />
                        </div>
                        <div id="pentest3">
                        <HeadingTitle title={datasPentest.pTenTitle} />
                        
                        <Paragraf parag={datasPentest.pTen} />
                        </div>
                        <div id="pentest4">
                            <HeadingTitle title={datasPentest.pElevenTitle} />
                            <Paragraf parag={datasPentest.pEleven} />
                        </div>
                        <div id="pentest5">
                            <div className="float-right img-fluid pl-lg-3 mb-1 img-iso-width">
                                <img
                                width="100%"
                                height="100%" 
                                src="/images/cyber/web_connect.png" 
                                alt="network wifi" />
                            </div>
                            <HeadingTitle title={datasPentest.pTwelveTitle} />
                            <Paragraf parag={datasPentest.pTwelve} />
                        </div>
                        <div id="pentest6">
                        <HeadingTitle title={datasPentest.pThirteenTitle} />
                        <Paragraf parag={datasPentest.pThirteen} />
                        </div>
                        <div id="pentest7"> 
                        <HeadingTitle title={datasPentest.pFourteenTitle} />
            
                        <Paragraf parag={datasPentest.pFourteen}  />
                        </div>
                        <div id="pentest8">
                        <HeadingTitle title={datasPentest.pFifteenTitle} />
                        <Paragraf parag={datasPentest.pFifteen}  />
                        </div>
                        <div id="pentest9">
                          <HeadingTitle title={datasPentest.pSixteenTitle} />
                            <Paragraf parag={datasPentest.pSixteen} />  
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    )
}

